import { Component } from '@angular/core';

import { ConsentService } from './consent.service';
import { COOKIE_NOTICE_URL, PRIVACY_POLICY_URL } from './legal-urls';

/**
 * Cookie consent banner for direct-to-app (unauthenticated, no prior choice)
 * visitors. Mirrors the marketing site's banner: analytics and advertising
 * categories (embeds aren't used in-app and are carried over from any prior
 * marketing choice by the ConsentService). Authenticated users are auto opted-in
 * to analytics elsewhere and never see this banner.
 */
@Component({
  selector: 'tablesready-consent-banner',
  templateUrl: './consent-banner.component.html',
  styleUrls: ['./consent-banner.component.scss'],
  standalone: false,
})
export class ConsentBannerComponent {
  showPreferences = false;
  analyticsChecked = false;
  adsChecked = false;

  readonly cookieNoticeUrl = COOKIE_NOTICE_URL;
  readonly privacyPolicyUrl = PRIVACY_POLICY_URL;

  constructor(readonly consentService: ConsentService) {}

  get gpcEnabled(): boolean {
    return this.consentService.gpcEnabled;
  }

  openPreferences(): void {
    const existing = this.consentService.read();
    this.analyticsChecked = !!existing?.analytics;
    this.adsChecked = !!existing?.ads && !this.gpcEnabled;
    this.showPreferences = true;
  }

  acceptAll(): void {
    this.consentService.acceptAll();
  }

  /** Close for this session without choosing — banner returns on next load. */
  dismiss(): void {
    this.consentService.dismissForSession();
  }

  rejectAll(): void {
    this.consentService.rejectAll();
    this.showPreferences = false;
  }

  savePreferences(): void {
    this.consentService.savePreferences(this.analyticsChecked, this.adsChecked);
    this.showPreferences = false;
  }
}
